import { isEqual } from 'lodash';

import { CA, UK, US } from './AccountConstants';

const UNITED_STATES = { id: 'US', name: 'United States' };
const CANADA = { id: 'CA', name: 'Canada' };
const UNITED_KINGDOM = { id: 'UK', name: 'United Kingdom' };

const CANADIAN_POSTAL_CODE_REGEXP = /^[ABCEGHJ-NPRSTVXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/i;
const US_POSTAL_CODE_REGEXP = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
const UK_POSTAL_CODE_REGEXP = /^[A-Z]{1,2}\d[A-Z\d]? \d[A-Z]{2}$/i;
const UNIVERSAL_POSTAL_CODE_REGEXP = /^[A-Za-z0-9\- ]{3,12}$/;

export const addInvalidFieldIfNotValid = (isNotValid, fieldName, collection) => {
  if (isNotValid) {
    collection.push(fieldName);
  }
};

export const isPhoneValid = phone => phone && phone?.length !== 0 && phone?.length === 14;
export const isPhoneValidForClient = phone => {
  return !phone || phone?.length === 14;
};

export const isValidEmail = email =>
  email &&
  email?.match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );

export const isValidEmailForPayee = email =>
  email.includes('@elligodirect.com') &&
  email?.match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );

export const isBlank = str => !str || /^\s*$/?.test(str);

export const isZipCodeValid = (zipCode, isUsCountry) => {
  const zipCodeLength = zipCode?.length;
  const postalCodeRegex = isUsCountry ? US_POSTAL_CODE_REGEXP : CANADIAN_POSTAL_CODE_REGEXP;

  return zipCode && (isUsCountry ? [5, 10] : [7]).includes(zipCodeLength) && postalCodeRegex.test(zipCode);
};

export const accountZipCodeValidation = (zipCode, country) => {
  const zipCodeLength = zipCode?.length;
  if (country === US) {
    return zipCode && [5, 10].includes(zipCodeLength) && US_POSTAL_CODE_REGEXP.test(zipCode);
  } else if (country === CA) {
    return zipCode && [7].includes(zipCodeLength) && CANADIAN_POSTAL_CODE_REGEXP.test(zipCode);
  }
  return zipCode && UNIVERSAL_POSTAL_CODE_REGEXP.test(zipCode);
};

export function onChangeZipCode(value, country, setCountry, zipCode, setZipCode, setState) {
  const normalizedValue = normalizeZipCodeForAccounts(value);
  if (CANADIAN_POSTAL_CODE_REGEXP.test(normalizedValue) && country?.id !== CANADA?.id) {
    setCountry(CANADA);
    setState(null);
  } else if (UK_POSTAL_CODE_REGEXP.test(normalizedValue) && country?.id !== UK) {
    setCountry(UNITED_KINGDOM);
    setState(null);
  } else if (normalizedValue === '' && (country?.id === CANADA?.id || country?.id === UK)) {
    setCountry(UNITED_STATES);
    setState(null);
  } else if (normalizedValue.match(/^\d/) && (country?.id === CANADA?.id || country?.id === UK)) {
    setCountry(UNITED_STATES);
    setState(null);
  }

  if (!isEqual(zipCode, value)) {
    setZipCode(normalizedValue);
  }
}

export function normalizeZipCodeForAccounts(value) {
  if (!value) return value;

  if (/[a-zA-Z]/g.test(value) && /^[A-Za-z]/.test(value.charAt(0))) {
    const currentValue = value
        .toUpperCase()
        .replace(/[^\dA-Z]/g, '')
        .replace(' ', ''),
      cvLength = currentValue.length;
    if (cvLength < 3) return currentValue;
    const maybeUKCode = /^[A-Z]{1,2}\d[A-Z\d]?/i.test(currentValue);
    if (maybeUKCode && cvLength >= 3 && currentValue.match(/[A-Z]{1,2}\d[A-Z\d]?\d[A-Z]{2}/i)) {
      const outwardLength = currentValue.match(/^[A-Z]{1,2}\d[A-Z\d]?/i)[0].length;
      if (currentValue.length >= 7) {
        return `${currentValue.slice(0, outwardLength)} ${currentValue.slice(outwardLength)}`.trim();
      } else {
        return `${currentValue.slice(0, currentValue.length - 3)} ${currentValue.slice(
          currentValue.length - 3
        )}`.trim();
      }
    }
    return `${currentValue.slice(0, 3)} ${currentValue.slice(3, 6)}`.trim();
  }

  const currentValue = value.replace(/[^\d]/g, ''),
    cvLength = currentValue.length;
  if (cvLength < 6) return currentValue;
  return `${currentValue.slice(0, 5)}-${currentValue.slice(5, 9)}`;
}
